const useCertificazioniConfigTable = () => {
    return [
      { key: "descrizione", label: "Descrizione" },
    ];
  };
  
  export default useCertificazioniConfigTable;
  